import React from 'react'
type Props = {
  zoom: string
  showZoomLevel: boolean
}

const ZoomDisplayControl: React.FC<Props> = ({ zoom, showZoomLevel }) => {
  if (!showZoomLevel) {
    return null
  }
  return (
    <button type="button" title="Zoom Level" aria-label="Zoom Level">
      <span
        className="mapboxgl-ctrl-button"
        style={{
          display: 'block',
          fontSize: '1.2em',
          fontWeight: 600
        }}
      >
        <span>{zoom}</span>
      </span>
    </button>
  )
}

export default ZoomDisplayControl
